<template>
  <div class="success" v-if="showSuccess" @click="closeSuccess">
    <div class="icon"></div>
    <div class="container">
      <div class="congratuation">恭喜</div>
      <div class="user">{{userTel}}用户成功开通</div>
      <div class="desc">{{text.desc}}</div>
      <div class="subDesc">{{text.subDesc}}</div>
      <div class="checkPriority" @click="clickHandle">查看我的会员权益</div>
    </div>
  </div>
</template>
<script>
  import localStorage from "@/utils/localStorage.js";

  export default {
    props: ['showSuccess', 'text'],
    methods: {
      clickHandle() {
        this.$emit('checkPriority');
      },
      closeSuccess() {
        this.$emit('closeSuccess');
      }
    },
    computed: {
      userTel() {
        let phone = '';
        let user = localStorage.get("user");
        phone = user.phone;
        phone = phone.split('');
        phone = phone.map((element, index) => {
          if (index >= 3 && index <= 6) {
            return '*';
          } else {
            return element;
          }
        })
        phone = phone.join('');
        return phone;
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "@/scss/_vars.scss";
  @import "../style/common.scss";
  .success {
    width: 100%;
    min-height: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    left: 0;
    .icon {
      width: 69*$px;
      height: 69*$px;
      background-color: #fff;
      position: absolute;
      left: 50%;
      top: 128*$px;
      z-index: 3;
      border-radius: 50%;
      @include bg('logo@3x.png');
      transform: translateX(-50%);
    }
    .container {
      position: absolute;
      left: 50%;
      top: 163*$px;
      z-index: 2;
      background-color: #fff;
      border-radius: 8*$px;
      transform: translateX(-50%);
      width: 315*$px;
      height: 256*$px;
      .congratuation {
        font-weight: 600;
        margin-top: 54*$px;
        text-align: center;
        font-size: 24*$px;
        color: #000000;
      }
      .user {
        margin-top: 11*$px;
        text-align: center;
        font-size: 16*$px;
        color: #000000;
        line-height: 28*$px;
      }
      .desc {
        margin-top: 2*$px;
        font-size: 16*$px;
        color: #F6A100;
        text-align: center;
        line-height: 28*$px;
      }
      .subDesc {
        font-size: 16*$px;
        color: #000000;
        text-align: center;
        line-height: 28*$px;
      }
      .checkPriority {
        text-align: center;
        position: fixed;
        bottom: 0;
        background: #F7E1B2;
        color: #BA792F;
        height: 50*$px;
        line-height: 50*$px;
        width: 100%;
        border-bottom-left-radius: 8*$px;
        border-bottom-right-radius: 8*$px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/goldSale/components/success.vue